import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@p81-common/ui';

export default makeStyles<Theme>(theme => ({
  subtitle: {
    ...theme.typography.caption1,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2)
  },
  regionLabel: {
    width: theme.spacing(6),
    paddingTop: theme.spacing(1.25),
    fontWeight: theme.typography.fontWeightBold
  },
  control: {
    flex: 1,
    minWidth: 0
  },
  dropdown: {
    minHeight: 0
  },
  linkBtn: {
    padding: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: theme.palette.primary.main
  },
  caption: {
    ...theme.typography.caption1,
    margin: theme.spacing(0.5, 0, 0, 9)
  },
  captionInfo: { color: theme.palette.primary.main },
  captionError: { color: theme.palette.error.main },
  captionAmber: { color: theme.palette.warning.main },
  captionSuccess: { color: theme.palette.success.main },
  banner: {
    ...theme.typography.caption1,
    padding: theme.spacing(1, 1.5),
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.secondary[100],
    color: theme.palette.secondary[700]
  },
  confirmItem: {
    display: 'block',
    marginTop: theme.spacing(1)
  }
}));
